export const GET_MENU_ATTRIBUTE_TYPES_LIST_REQUESTED = 'menuAttributeTypes/GET_MENU_ATTRIBUTE_TYPES_LIST_REQUESTED';
export const GET_MENU_ATTRIBUTE_TYPES_LIST_SUCCESS = 'menuAttributeTypes/GET_MENU_ATTRIBUTE_TYPES_LIST_SUCCESS';
export const GET_MENU_ATTRIBUTE_TYPES_LIST_FAILURE = 'menuAttributeTypes/MENU_ATTRIBUTE_TYPES_LIST_FAILURE';

export const ADD_MENU_ATTRIBUTE_TYPE_REQUESTED = 'menuAttributeTypes/ADD_MENU_ATTRIBUTE_TYPE_REQUESTED';
export const ADD_MENU_ATTRIBUTE_TYPE_SUCCESS = 'menuAttributeTypes/ADD_MENU_ATTRIBUTE_TYPE_SUCCESS';
export const ADD_MENU_ATTRIBUTE_TYPE_FAILURE = 'menuAttributeTypes/ADD_MENU_ATTRIBUTE_TYPE_FAILURE';

export const UPDATE_MENU_ATTRIBUTE_TYPE_REQUESTED = 'menuAttributeTypes/UPDATE_MENU_ATTRIBUTE_TYPE_REQUESTED';
export const UPDATE_MENU_ATTRIBUTE_TYPE_SUCCESS = 'menuAttributeTypes/UPDATE_MENU_ATTRIBUTE_TYPE_SUCCESS';
export const UPDATE_MENU_ATTRIBUTE_TYPE_FAILURE = 'menuAttributeTypes/UPDATE_MENU_ATTRIBUTE_TYPE_FAILURE';

export const DELETE_MENU_ATTRIBUTE_TYPE_REQUESTED = 'menuAttributeTypes/DELETE_MENU_ATTRIBUTE_TYPE_REQUESTED';
export const DELETE_MENU_ATTRIBUTE_TYPE_SUCCESS = 'menuAttributeTypes/DELETE_MENU_ATTRIBUTE_TYPE_SUCCESS';
export const DELETE_MENU_ATTRIBUTE_TYPE_FAILURE = 'menuAttributeTypes/DELETE_MENU_ATTRIBUTE_TYPE_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  menuAttributeTypesList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_ATTRIBUTE_TYPES_LIST_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case GET_MENU_ATTRIBUTE_TYPES_LIST_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
        menuAttributeTypesList: action.result,
      };
    }
    case GET_MENU_ATTRIBUTE_TYPES_LIST_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
        menuAttributeTypesList: [],
      };
    }
    case ADD_MENU_ATTRIBUTE_TYPE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case ADD_MENU_ATTRIBUTE_TYPE_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
      };
    }
    case ADD_MENU_ATTRIBUTE_TYPE_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
      };
    }
    case UPDATE_MENU_ATTRIBUTE_TYPE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case UPDATE_MENU_ATTRIBUTE_TYPE_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
      };
    }
    case UPDATE_MENU_ATTRIBUTE_TYPE_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
      };
    }
    case DELETE_MENU_ATTRIBUTE_TYPE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case DELETE_MENU_ATTRIBUTE_TYPE_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: false,
      };
    }
    case DELETE_MENU_ATTRIBUTE_TYPE_FAILURE: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getMenuAttributeTypesList = () => {
  return {
    types: [GET_MENU_ATTRIBUTE_TYPES_LIST_REQUESTED, GET_MENU_ATTRIBUTE_TYPES_LIST_SUCCESS, GET_MENU_ATTRIBUTE_TYPES_LIST_FAILURE],
    promise: client => client.get('getMenuAttributeTypesLIst')
  };
};

export const addMenuAttributeType = (data) => {
  return {
    types: [ADD_MENU_ATTRIBUTE_TYPE_REQUESTED, ADD_MENU_ATTRIBUTE_TYPE_SUCCESS, ADD_MENU_ATTRIBUTE_TYPE_FAILURE],
    promise: client => client.post('addMenuAttributeType', { data })
  };
};

export const updateMenuAttributeType = (data) => {
  return {
    types: [UPDATE_MENU_ATTRIBUTE_TYPE_REQUESTED, UPDATE_MENU_ATTRIBUTE_TYPE_SUCCESS, UPDATE_MENU_ATTRIBUTE_TYPE_FAILURE],
    promise: client => client.post('updateMenuAttributeType', { data })
  };
};

export const deleteMenuAttributeType = (menuAttributeTypeId) => {
  return {
    types: [DELETE_MENU_ATTRIBUTE_TYPE_REQUESTED, DELETE_MENU_ATTRIBUTE_TYPE_SUCCESS, DELETE_MENU_ATTRIBUTE_TYPE_FAILURE],
    promise: client => client.post(`deleteMenuAttributeType/${menuAttributeTypeId}`)
  };
};
